module.exports = __webpack_public_path__ + "img/close-upgrade-icon.b6e296d8.png";